export default __webpack_public_path__ + "static/media/010103202120100.76efca5e.png";